import { Loader2 } from 'lucide-react';

/** Modal footer with a Cancel button and a form-submit button.
 *
 * Extracted verbatim from the store-management modal forms
 * (MarketRegularizationReasonsPage / StoreCategoriesPage), where this exact
 * markup was duplicated. The submit button is associated with an external
 * `<form id={formId}>` via the `form` attribute, shows a spinner while
 * submitting, and is disabled during submission. Callers pass their own
 * cancel handler, the target form id, the submitting flag, and the submit
 * button label. */
export function ModalFormFooter({
  onCancel,
  formId,
  isSubmitting,
  submitLabel,
  cancelLabel = 'Cancel',
}: {
  onCancel: () => void;
  formId: string;
  isSubmitting: boolean;
  submitLabel: string;
  cancelLabel?: string;
}) {
  return (
    <div className="flex w-full flex-col gap-3 sm:flex-row sm:justify-end">
      <button
        type="button"
        className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        onClick={onCancel}
      >
        {cancelLabel}
      </button>
      <button
        type="submit"
        form={formId}
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700 disabled:opacity-50"
        disabled={isSubmitting}
      >
        {isSubmitting && <Loader2 className="h-4 w-4 animate-spin" />}
        {submitLabel}
      </button>
    </div>
  );
}
